{
  "component": {
    "portrait": {
      "caddie_placeholder": "{name}: caddie art placeholder",
      "your_caddie": "{name}, your caddie"
    },
    "chart": {
      "legend": "Legend: {items}",
      "against": "Against {benchmark}",
      "average": "Average: {distance} {side, select, left {left} other {right}}",
      "spread": "Spread: {distance}",
      "shots": "Shots: {n}",
      "par": "Par {par}"
    },
    "commerce": {
      "per_month": "{price} a month",
      "per_year": "or {price} a year"
    },
    "currency": {
      "price_label": "Price {price}"
    },
    "meter": {
      "done": "{completed} of {total} done",
      "step": "Step {current} of {total}"
    },
    "round": {
      "shot_header": "Hole {hole} · Shot {shot} · {club}",
      "strokes_gained": "SG {value}",
      "shot_club": "Shot {shot} · {club}",
      "par": "Par {par}"
    },
    "score": {
      "moved": "{direction, select, up {up} other {down}} {n} places"
    },
    "scorecard": {
      "hole_label": "Hole {n}, par {par}, {length}, stroke index {si}{received, plural, =0 {} one {, # shot received} other {, # shots received}}{gross, select, none {} other {, {gross}}}"
    },
    "skills": {
      "limit": "Limit {low}–{high}{ceiling, select, none {} other { · age ceiling {ceiling}}}"
    },
    "weather": {
      "wind_label": "Wind {speed} miles an hour",
      "conditions_label": "{conditions}, {temp} degrees"
    }
  },
  "screen": {
    "event": {
      "field_subtitle": "{entered} entered so far, {field} places"
    },
    "report": {
      "ai_late": "The result is ready. The match report is still being prepared."
    },
    "golfer": {
      "age_line": "Age {age} · birthday in 23 days",
      "home_club": "Home club: {club}",
      "shots": "{value} shots"
    },
    "handicap": {
      "round_label": "{date}, {course}, {gross}, round differential {differential}{counting, select, yes {, counts} other {}}"
    },
    "home": {
      "greeting": "Good morning, {name}",
      "date_club": "Thursday 9 October · {club}"
    },
    "leaderboard": {
      "position_thru": "{tied, select, yes {T} other {}}{position} · thru {thru}"
    },
    "live_round": {
      "one_tap_label": "One tap plays: ",
      "one_tap_shot": "8 iron, stock height, at the flag."
    },
    "training": {
      "week_subtitle": "{week} · {hours} golf hours a day",
      "day_label": "{day}, {used} of {total} hours planned. Edit this day",
      "day_hours": "{used} of {total} h"
    },
    "parts": {
      "offline": "You're offline. This is what we had at {updated}. Anything that needs a connection waits."
    }
  },
  "spike": {
    "fps": "{platform} · {fps} fps"
  },
  "notice": {
    "in_game_advice": "This is not real-life advice. It only applies to your golfer in the game."
  },
  "depth": {
    "label": "Detail",
    "simple": "Simple",
    "standard": "Standard",
    "everything": "Everything",
    "chip": {
      "simple": "Detail: Simple",
      "standard": "Detail: Standard",
      "everything": "Detail: Everything"
    },
    "hint": {
      "simple": "Simple: the main facts.",
      "standard": "Standard: the facts and the figures behind them.",
      "everything": "Everything: every figure the game keeps."
    },
    "settings_note": "This changes what you see, never how a round is played.",
    "breakdown_note": "The full text of every shot is there at every step, if you tap for it."
  }
}
